import { ProfileTarget } from "@welldigital/ui-common/Authentication";

// Profiles
export const PHARMACY: ProfileTarget = "pharmacy";
export const ONLINE_SERVICES: ProfileTarget = "online-services";
